export const OrganizationSettings: any = {
    UserManualLink: 'UserManualLink',
    FacilitatorManualLink: 'FacilitatorManualLink',
    HeaderBackgroundColor: 'HeaderBackgroundColor',
    HeaderTextColor: 'HeaderTextColor',
    SponsoredContentImage: 'SponsoredContentImage',
    UsersBulkUploadTemplate: 'UsersBulkUploadTemplate',
    LogoHeight: 'LogoHeight',
};
